var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.275 12.8108L6.06107 11.4061C3.70786 10.6217 2.53125 10.2295 2.53125 9.50874C2.53125 8.78798 3.70786 8.39578 6.06107 7.61138L18.5077 3.46252C20.1634 2.91059 20.9913 2.63462 21.4284 3.07164C21.8654 3.50865 21.5894 4.33655 21.0375 5.99234L16.8886 18.4389L16.8886 18.4389C16.1042 20.7921 15.712 21.9687 14.9912 21.9687C14.2705 21.9687 13.8783 20.7921 13.0939 18.4389L13.0939 18.4389L11.6892 14.225L16.9169 8.99733C17.3074 8.6068 17.3074 7.97364 16.9169 7.58311C16.5264 7.19259 15.8932 7.19259 15.5027 7.58311L10.275 12.8108Z",
    fill: "#5F6C8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/shipped.60f48dac5bdcb1df0309fd049b9f3c59.svg";
export { ForwardRef as ReactComponent };